import * as Yup from "yup";

const indicadorFinanceiroValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  tipo: Yup.string().required("Tipo"),
});

export default indicadorFinanceiroValidator;
